import Vue from 'vue';
import Router from 'vue-router';
import jRouterLogin from './jRouterLogin';
import jRouterLogout from './jRouterLogout';
import jRouterHome from './jRouterHome';
import jRouterApp from './jRouterApp';
import jRouterSetting from './jRouterSetting';
import jRouterCompany from './jRouterCompany';
import jRouterCanvas from './jRouterCanvas';
import jRouterAutomation from './jRouterAutomation';
import jRouterForm from './jRouterForm';
import jRouterDataConnectivity from './jRouterDataConnectivity';
import jRouterUser from './jRouterUser';
import jRouterPosition from './jRouterPosition';
import jRouterLayer from './jRouterLayer';
import jRouterDivision from './jRouterDivision';
import jRouterLocation from './jRouterLocation';
import jRouterFlowRules from './jRouterFlowRules';
import jRouterThirdParty from './jRouterThirdParty';
import jRouterAi from './jRouterAi';
import jRouterAccess from './jRouterAccess';
import jRouterJoana from './jRouterJoana';
import jRouterVP from './jRouterVP';

Vue.use(Router);

const moduleRoutes = [
  jRouterLogin,
  jRouterLogout,
  jRouterHome,
  jRouterApp,
  jRouterCompany,
  jRouterSetting,
  jRouterCanvas,
  jRouterAutomation,
  jRouterForm,
  jRouterDataConnectivity,
  jRouterUser,
  jRouterPosition,
  jRouterLayer,
  jRouterDivision,
  jRouterLocation,
  jRouterFlowRules,
  jRouterThirdParty,
  jRouterAi,
  jRouterAccess,
  jRouterJoana,
  jRouterVP,
];

const baseRoutes = [
  {
    path: '*',
    redirect: '/',
  },
];

const routes = baseRoutes.concat(...moduleRoutes);

const router = new Router({
  mode: 'hash',
  routes,
});


// validate route by middleware
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];

  if (!subsequentMiddleware) return context.next;

  return () => {
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };

    const nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({ ...context, next: nextMiddleware });
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js